var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3821 7.8124L10.5487 2.70823C10.2345 2.43332 9.76541 2.43332 9.45123 2.70823L3.61789 7.8124C3.43705 7.97064 3.33331 8.19924 3.33331 8.43954V15.8332C3.33331 16.2935 3.70641 16.6666 4.16665 16.6666H15.8333C16.2935 16.6666 16.6666 16.2935 16.6666 15.8332V8.43954C16.6666 8.19924 16.5629 7.97064 16.3821 7.8124Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2071 9.87376C13.5976 9.48324 13.5976 8.85007 13.2071 8.45955C12.8166 8.06903 12.1834 8.06903 11.7929 8.45955L13.2071 9.87376ZM9.16667 12.5L8.45956 13.2071C8.85008 13.5976 9.48325 13.5976 9.87377 13.2071L9.16667 12.5ZM8.20711 10.1262C7.81658 9.73569 7.18342 9.73569 6.79289 10.1262C6.40237 10.5167 6.40237 11.1499 6.79289 11.5404L8.20711 10.1262ZM11.7929 8.45955L8.45956 11.7929L9.87377 13.2071L13.2071 9.87376L11.7929 8.45955ZM9.87377 11.7929L8.20711 10.1262L6.79289 11.5404L8.45956 13.2071L9.87377 11.7929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCheck);
export default __webpack_public_path__ + "static/media/HomeCheck.39b2013d.svg";
export { ForwardRef as ReactComponent };